import { List } from 'immutable';
import { isFieldRestricted } from '../../../utils/fieldLevelPermissions';
import { useState } from 'react';
import { useQuickFilterResolverAndOptions } from '../../../hooks/useQuickFilterResolverAndOptions';
// @ts-expect-error untyped
import ReferenceInputEnum from 'customer-data-reference-ui-components/ReferenceInputEnum';
// @ts-expect-error untyped
import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
import { jsx as _jsx } from "react/jsx-runtime";
const ReferenceEnumQuickFilterButton = ({
  ButtonContent,
  buttonProperties,
  dropdownFooter,
  filterFamily,
  isOptionsSelectDisabled,
  placement,
  property,
  value,
  onChange
}) => {
  const isRestrictedField = isFieldRestricted(property.accessLevel);
  const [isOpen, setIsOpen] = useState(false);
  const {
    resolver,
    options
  } = useQuickFilterResolverAndOptions(filterFamily, isOptionsSelectDisabled, property);
  const onOpenChange = evt => {
    setIsOpen(evt.target.value);
  };
  const optionFormatter = record => {
    const option = ReferenceRecord.toOption(record);
    return Object.assign({}, option, {
      disabled: isOptionsSelectDisabled
    });
  };
  return /*#__PURE__*/_jsx(ReferenceInputEnum
  // used for rerendering options
  , {
    "data-test-id": `reference-enum-${property.name}`,
    ButtonContent: ButtonContent,
    buttonSize: buttonProperties.BUTTON_SIZE,
    buttonUse: buttonProperties.BUTTON_USE,
    clearable: true,
    disabled: isRestrictedField || property.disabled,
    dropdownFooter: dropdownFooter,
    onChange: onChange,
    onOpenChange: onOpenChange,
    open: isOpen,
    optionFormatter: optionFormatter,
    options: options,
    placement: placement,
    menuWidth: "auto",
    multi: true,
    resolver: resolver,
    showTags: false,
    value: List(value),
    ignoreAccents: false
  }, isOptionsSelectDisabled ? 'reference-none' : 'reference-all');
};
export default ReferenceEnumQuickFilterButton;